module.exports = __webpack_public_path__ + "static/img/product_images_big27_h5_zh.a39f661.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/product_images_big27_h5_zh.png
// module id = 4sm/
// module chunks = 34